import {Pressable, StyleSheet, View, ViewStyle} from "react-native";
import {UserAvatar} from "@/lib/types";
import Avatar from "@/lib/components/Avatar";
import {ReactNode} from "react";

type Props = {
    avatars: UserAvatar[],
    color: string,
    extraInvited?: number,
    size?: number,
    border?: boolean,
    onPress?: () => any,
    children?: ReactNode;
}

export default function AvatarBox({avatars, color, children, border, size, onPress}: Props) {
    const borderStyle: ViewStyle = border === false ? {} : {
        borderRadius: 7,
        borderWidth: 1,
        paddingVertical: 6,
        paddingHorizontal: 12,
        borderColor: color,
    };
    return (
        <Pressable style={[styles.container, borderStyle]} disabled={!onPress} onPress={onPress}>
            <View style={styles.inner}>
                {avatars.map(avatar => <Avatar key={avatar.id} size={size} avatar={avatar} pressable={!onPress}/>)}
            </View>
            {children}
        </Pressable>
    );
}

export const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%",
        alignItems: "center",
        gap: 8,
    },
    inner: {
        flexDirection: "row",
        gap: 4,
    }
})